import { gql, useMutation } from '@apollo/client';

const UPDATE_ORG_FACULTY = gql`
  mutation UpdateOrgFaculty($id: ID!, $input: UpdateFacultyInput!) {
    updateOrgFaculty(id: $id, input: $input) {
      _id
      abbreviation
      title
      effectiveFrom
      effectiveTo
      school
      isActive
      frcSecretaries {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      frcChair {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      dean {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
    }
  }
`;

export const useUpdateOrgFaculty = (): any => {
  const [updateOrgFaculty, { data, loading, error }] =
    useMutation(UPDATE_ORG_FACULTY);

  return { updateOrgFaculty, data, loading, error };
};
